package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSep182022StrAIberryLiveDetectionChallengePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/sep182022StrAIberryLiveDetectionChallenge.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/sep182022-str-a-iberry-live-detection-challenge")
@Composable
fun Sep182022StrAIberryLiveDetectionChallengePage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("sep-18-2022-straiberry-live-detection-challenge") }) {
        org.jetbrains.compose.web.dom.Text("sep-18-2022-StrAIberry-live-detection-challenge")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A live detection system was the primary idea for StrAIberry.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("live")
        }
        org.jetbrains.compose.web.dom.Text(" side, Thanks to ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("camerax")
        }
        org.jetbrains.compose.web.dom.Text(" with its awesome plugin called ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Analyzer")
        }
        org.jetbrains.compose.web.dom.Text(", getting frames from camera in a thread-safe environment was really easy. You could use its observer to get the frames that camera fires based on your preferences.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("detection")
        }
        org.jetbrains.compose.web.dom.Text(" side, at first we used Pytorch mobile because the model itself was also with Pytorch. we wanted to use it directly in order to not disturb its speed and accuracy but then we decided to convert it into a ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("tflite")
        }
        org.jetbrains.compose.web.dom.Text(" model for 3 reason, better support for Android, no latency in both speed and accuracy and better documentation.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At the time using google codelab was a big help for us as the client developers. We could test and debug our inputs on the early stages.")
    }
}
